import { makeStyles, List, Typography, Grid } from "@material-ui/core";
import { Mail, Phone, WhatsApp } from "@material-ui/icons";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import useUserFormFunctions from "../../hooks/useUserFormFunctions";
import { selectCleverlynk, selectCompany } from "../../redux/slices/cleverlynkSlice";

export interface ICompanyContactInfo {
  whatsapp: string[];
  phone: string[];
  email: string[];
  instagram?: string | undefined;
}

const useStyles = makeStyles(theme => ({
  nested: {
    paddingLeft: theme.spacing(6),
  },
}));

const FooterContactInfo = ({ color }) => {
  const company = useSelector(selectCompany);
  const cleverlynk = useSelector(selectCleverlynk);
  const [contacts, setContacts] = useState<ICompanyContactInfo>({ whatsapp: [], phone: [], email: [] });
  const { isValidEmail } = useUserFormFunctions();
  const classes = useStyles();

  useEffect(() => {
    let addAction: ICompanyContactInfo = {
      whatsapp: [],
      phone: [],
      email: [],
    };

    if (cleverlynk?.phone && cleverlynk?.phone.length > 6) addAction.phone.push(cleverlynk.phone);
    if (company?.phones && company?.phones!.length > 0)
      addAction.phone.push(...company.phones.filter(p => !p.includes("+573")));

    if (cleverlynk?.whatsapp && cleverlynk.whatsapp.length > 6) addAction.whatsapp.push(cleverlynk.whatsapp);
    if (company?.phones && company?.phones!.length > 0)
      addAction.whatsapp.push(...company.phones.filter(p => p.includes("+573")));

    if (cleverlynk?.email && isValidEmail(cleverlynk.email)) addAction.email.push(cleverlynk.email);
    if (company?.mails && company?.mails.length > 0) addAction.email.push(...(company.mails as string[]));

    setContacts(addAction);
  }, [cleverlynk, company?.mails, company?.phones]);

  const renderSubList = (items: string[], name: string, icon: any, action: string) => (
    <React.Fragment>
      <div style={{ marginLeft: 5, color }}>
        <Typography variant="overline">{name}</Typography>
        {items.map((c, i) => (
          <Grid container>
            <Grid item xs={12} container wrap="nowrap">
              {icon}
              <Typography
                style={{ marginLeft: 5, lineHeight: 1.7, cursor: "pointer" }}
                variant="body2"
                onClick={() => window.open(action + c)}>
                {c}
              </Typography>
            </Grid>
          </Grid>
        ))}
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      {contacts.whatsapp.length > 0 &&
        renderSubList(
          contacts.whatsapp,
          "WhatsApp",
          <WhatsApp />,
          `https://api.whatsapp.com/send?text=Hola, me gustaría tener más información de la tienda online de ${cleverlynk?.name}&phone=`
        )}
      {contacts.phone.length > 0 && renderSubList(contacts.phone, "Teléfonos", <Phone />, `tel:`)}
      {contacts.email.length > 0 && renderSubList(contacts.email, "Correo", <Mail />, `mailto:`)}
    </React.Fragment>
  );
};
export default FooterContactInfo;
